import type { DocHostClient } from '../ui/formats/DocView'

const hosts = new Map<string, DocHostClient>()

/** Register the browser adapter for one server-side document host. */
export function registerDocHostClient(
  host: string,
  client: DocHostClient,
): void {
  hosts.set(host, client)
}

/** Resolve a document host. Missing registration is an application wiring fault. */
export function docHostClient(host: string): DocHostClient {
  const client = hosts.get(host)
  if (!client)
    throw new Error(`No document host client is registered for ${host}.`)
  return client
}
